import React from 'react'
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews'
import { useStaticQuery, graphql } from 'gatsby'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import MenuIcon from '@mui/icons-material/Menu'
import IconButton from '@mui/material/IconButton'
import SideBar from 'src/components/organisms/SideBar'
import NavLinks from 'src/components/molecules/NavLinks'
import Logo from 'src/components/atoms/Logo'
import {
  AllDocumentTypes,
  NavigationDocumentDataBodyMenuSlice,
  NavigationDocumentDataBodySubmenuSlice,
  NavigationDocumentDataBodyLinksSlice,
  NavigationDocumentDataBodyButtonsSlice,
} from '../../../../types.generated'
import useSlice from 'src/hooks/useSlice'
import NavigationButtons from './../../molecules/NavigationButtons/NavigationButtons'

const SiteNav = ({ data }: AllDocumentTypes): JSX.Element => {

  const prismicNavigation = useSlice(
    data.prismicNavigation,
    'menu',
  ) as NavigationDocumentDataBodyMenuSlice
  const prismicSubNavigation = useSlice(
    data.prismicNavigation,
    'submenu',
  ) as NavigationDocumentDataBodySubmenuSlice

  const prismicNavigationLinks = useSlice(
    data.prismicNavigation,
    'links',
  ) as NavigationDocumentDataBodyLinksSlice

  const prismicNavigationButtons = useSlice(
    data.prismicNavigation,
    'buttons',
  ) as NavigationDocumentDataBodyButtonsSlice

  const [drawerOpen, setDrawerOpen] = React.useState(false)

  const handleDrawerOpen = () => {
    setDrawerOpen(true)
  }

  const handleDrawerClose = () => {
    setDrawerOpen(false)
  }

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return
      }

      setDrawerOpen(open)
    }
  return (
    <>
      <Container
        maxWidth="lg"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          py: {
            xs: 2,
            lg: 8,
          },
          backgroundColor: 'transaprent',
          mb: -20,
        }}
      >
        <Box sx={{ minWidth: 86, width: 86, height: '18px', mr: { xs: 3, lg: 6 } }}>
          <Logo />
        </Box>
        <Box
          sx={{
            minWidth: '33rem',
            display: { md: 'flex', xs: 'none' },
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <NavLinks
            variant="body2"
            menu={prismicNavigation.items}
            submenu={prismicSubNavigation.items}
          />
        </Box>
        <Box sx={{ ml: 'auto', display: { md: 'block', xs: 'none' } }}>
          <NavigationButtons buttons={prismicNavigationButtons?.items} />
        </Box>
        <Box sx={{ ml: 'auto', display: { md: 'none', xs: 'block' } }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
          >
            <MenuIcon color="primary" />
          </IconButton>
        </Box>
        <SideBar
          open={drawerOpen}
          toggleDrawer={toggleDrawer}
          closeDrawer={handleDrawerClose}
          links={prismicNavigationLinks.items}
          buttons={prismicNavigationButtons.items}
        />
      </Container>
    </>
  )
}

const SiteNavWrapper = withPrismicPreview(SiteNav)

const SiteNavWithData = () => {
  const data = useStaticQuery(graphql`
    {
      prismicNavigation {
        _previewable
        data {
          body {
            ... on PrismicNavigationDataBodyMenu {
              items {
                id {
                  text
                }
                label {
                  text
                }
                title {
                  text
                }
                url {
                  text
                }
                url_external {
                  text
                }
                hide
                dropdown
              }
              slice_type
            }
            ... on PrismicNavigationDataBodySubmenu {
              items {
                submenu_id
                menu_id {
                  text
                }
                title {
                  text
                }
                url {
                  text
                }
                url_external {
                  text
                }
                hide
              }
              slice_type
            }
            ... on PrismicNavigationDataBodyLinks {
              items {
                link_id
                url {
                  text
                }
                url_external {
                  text
                }
                hide
                title {
                  text
                }
              }
              slice_type
            }
            ... on PrismicNavigationDataBodyButtons {
              items {
                button_id
                url {
                  text
                }
                url_external {
                  text
                }
                hide
                title {
                  text
                }
                variant {
                  text
                }
              }
              slice_type
            }
          }
        }
      }
    }
  `);

  return <SiteNavWrapper data={data} />
}

export default SiteNavWithData
